import { Routes, Route } from 'react-router-dom';
import LoginPage from './Components/Login/LoginPage.js';
import EmailVerification from './Components/Activate/EmailVerification.js';
import FinishGoogle from './Components/Login/FinishGoogle.js';
import FinishFacebook from './Components/Login/FinishFacebook';
import FinishApple from './Components/Apple/FinishApple';
import UnknownError from './Components/UnknownError';
import ResetPassword from './Components/Reset/ResetPassword';
import ActivateAccount from './Components/Activate/ActivateAccount.js';
import ResetParent from './Components/Reset/ResetParent.js';
import RegisterPage from './Components/Register/RegisterPage';
import CompleteLogin from './Components/Code/CompleteLogin';
import Dealer from './Components/Dealer/Dealer';
import GoogleButton from './Components/Views/TO/Login/GoogleButton';
import FacebookButton from './Components/Views/TO/Login/FacebookButton';
import AppleButton from './Components/Views/TO/Login/AppleButton';
import Logout from './Components/Logout';
import JoinNow from './Components/Login/JoinNow';
import NoEmail from './Components/Apple/NoEmail';

function AppRoutes(props) {
    return (
        <Routes>
            <Route path="/join" element={<JoinNow />} />
            <Route path="/noemail" element={<NoEmail />} />
            <Route path="/register/external/google" element={<GoogleButton implicitRegister={true} />} />
            <Route path="/register/external/facebook" element={<FacebookButton implicitRegister={true} />} />
            <Route path="/register/external/apple" element={<AppleButton implicitRegister={true} />} />
            <Route path="/activate" element={<ActivateAccount />} />
            <Route path="/password" element={<ResetParent />} />
            <Route path="/resend" element={<EmailVerification external={false} embedded={false} login_uri={window.location.href} />} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/otplogin" element={<CompleteLogin signInType={"OTP"} />} />
            <Route path="/emailverification" element={<EmailVerification external={true} embedded={true} />} />
            <Route path="/phoneverification" element={<CompleteLogin signInType={"PHONE"} />} />
            <Route path="/emailcodeverification" element={<CompleteLogin signInType={"EMAIL"} />} />
            <Route path="/unknownerror" element={<UnknownError />} />
            <Route path="/google" element={<FinishGoogle />} />
            <Route path="/facebook" element={<FinishFacebook />} />
            <Route path="/apple" element={<FinishApple />} />
            <Route path="/dealer" element={<Dealer />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="*" element={<LoginPage />} />
        </Routes>
    );
}

export default AppRoutes;